import * as React from "react";

import AppModals from "@app/AppModals";
import { FullScreenLoader } from "@v2/components/FullScreenLoader";
import { ProjectWebsocketProvider } from "@v2/features/multiplayer/ProjectWebsocketProvider";
import useCurrentProjectId from "@v2/hooks/useCurrentProjectId";
import { trackOpencodeScaffoldError } from "@v2/infra/scaffoldSentry";
import { Outlet } from "react-router-dom";

export default function ChatLayout() {
  const projectId = useCurrentProjectId();

  // Note (Nick, 2026-02-23, REPL-23283): Listen for client-side errors from the
  // cloudflare scaffold iframe and send them to the opencode Sentry project.
  // This lives in ChatLayout (mounted once) rather than PageRenderer to avoid
  // duplicate reports
  React.useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type !== "replo-editor:client-error") {
        return;
      }

      const payload = event.data.payload;
      if (!payload?.error?.message) {
        return;
      }

      const error = new Error(payload.error.message);
      if (payload.error.stack) {
        error.stack = payload.error.stack;
      }
      trackOpencodeScaffoldError(error, {
        pageRoute: payload.pageRoute ?? "",
        stack: payload.error.stack,
        componentStack: payload.error.componentStack,
      });
    };

    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  if (!projectId) {
    return <FullScreenLoader />;
  }

  return (
    <ProjectWebsocketProvider projectId={projectId}>
      <div className="flex flex-col w-full h-full min-h-0 overflow-hidden">
        <AppModals />
        <Outlet />
      </div>
    </ProjectWebsocketProvider>
  );
}
